/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BillOfQuantity } from 'src/app/_model/bill-of-quantity';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { BillOfQuantitiesDaoService } from '../bill-of-quantities-dao.service';

// CONSTANTS
const BILLOFQUANTITIES_KEY = 'bill-of-quantities';

@Injectable()
export class BillOfQuantitiesStorageDaoService implements BillOfQuantitiesDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveBillOfQuantities(billOfQuantities: BillOfQuantity[]): Promise<void> {
    return this.keyValueStorage.store(BILLOFQUANTITIES_KEY, billOfQuantities);
  }
  public getBillOfQuantities(): Promise<BillOfQuantity[]> {
    return this.keyValueStorage.load(BILLOFQUANTITIES_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(BILLOFQUANTITIES_KEY);
  }
}
